import React from 'react'
import * as StyledComponent from '../styles'
import IconCrossDark from '../images/icon_cross_dark.svg'

const BottomSheetSelectList = (props, context) => {
  return <StyledComponent.BottomSheetSelectList>
    <div className='title-container'>
      <h1 className='title'>{props.title}</h1>
      <img
        className='close-btn'
        alt=''
        src={IconCrossDark}
        onClick={props.onClose.bind(this, false)}
      />
    </div>
    <div className='title-border' />
    <div className='list-container'>
      { props.list }
    </div>
  </StyledComponent.BottomSheetSelectList>
}

export default BottomSheetSelectList



// WEBPACK FOOTER //
// ./src/components/BottomSheetSelectList.js